import { PublicLayout } from "@/components/layout/PublicLayout";
import { LEGAL_UPDATED } from "@/data/legal";

export const LegalPage = ({ title, intro, sections, testid }) => {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-24 lg:px-8" data-testid={testid}>
        <p className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-primary">
          Legal
        </p>
        <h1 className="mt-3 font-heading text-4xl font-black tracking-tighter text-slate-900 sm:text-5xl">
          {title}
        </h1>
        <p className="mt-3 font-body text-sm font-medium text-slate-400">Last updated: {LEGAL_UPDATED}</p>
        {intro && (
          <p className="mt-6 font-body leading-relaxed text-slate-600">{intro}</p>
        )}

        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-heading text-lg font-bold tracking-tight text-slate-900">
                {s.heading}
              </h2>
              <p className="mt-2 font-body leading-relaxed text-slate-600">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
};
